import actions from './actions'
import mutations from './mutations'

const dialog = {
  namespaced: true,
  state: {
    visible: false,
    catalog: {},
    section: {}
  },
  mutations: mutations,
  actions: actions
}

export default dialog



// WEBPACK FOOTER //
// ./src/store/dialog/index.js